import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { CreateAnnouncementData, UpdateAnnouncementData, announcementsApi } from '@/services';

export const adminAnnouncementsKeys = {
  all: ['admin', 'announcements'] as const,
  list: () => [...adminAnnouncementsKeys.all, 'list'] as const,
};

export function useAdminAnnouncementsListQuery() {
  return useQuery({
    queryKey: adminAnnouncementsKeys.list(),
    queryFn: () => announcementsApi.getAll(),
  });
}

export function useCreateAnnouncementMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateAnnouncementData) => announcementsApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminAnnouncementsKeys.all });
    },
  });
}

export function useUpdateAnnouncementMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateAnnouncementData }) => announcementsApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminAnnouncementsKeys.all });
    },
  });
}

export function useActivateAnnouncementMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => announcementsApi.activate(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminAnnouncementsKeys.all });
    },
  });
}

export function useDeactivateAnnouncementMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => announcementsApi.deactivate(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminAnnouncementsKeys.all });
    },
  });
}

export function useDeleteAnnouncementMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => announcementsApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminAnnouncementsKeys.all });
    },
  });
}
